import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alkindivv.site/components/common/AboutPreview.tsx");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/components/common/DiscussionPreview.tsx");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/components/common/GlossaryPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alkindivv.site/components/common/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alkindivv.site/components/common/LatestBlogPosts.tsx");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
